// Project name
export const PROJECT_NAME = 'needful-things-mvp';

// Base domain (configure this for your project)
export const DOMAIN_BASE = 'needful-things-mvp.com';

// Cloudflare Worker (static assets) that hosts the admin app
export const ADMIN_APP_NAME = `${PROJECT_NAME}-admin`;

// R2 bucket used for uploads and static assets
export const R2_BUCKET = `${PROJECT_NAME}-uploads`;

// Environment-specific configuration
export const ENVIRONMENTS = {
  production: 'production',
  staging: 'staging',
} as const;

export type Environment = keyof typeof ENVIRONMENTS;

// Domain configuration by app and environment
export const DOMAINS: Record<string, Record<Environment, string>> = {
  admin: {
    production: `admin.${DOMAIN_BASE}`,
    staging: 'needfulthings.moureau.dev',
  },
  api: {
    production: `api.${DOMAIN_BASE}`,
    staging: 'needful-api.moureau.dev',
  },
  cdn: {
    production: `cdn.${DOMAIN_BASE}`,
    staging: 'cdn-needfulthings.moureau.dev',
  },
  registry: {
    production: `registry.${DOMAIN_BASE}`,
    staging: 'registry.moureau.dev',
  },
};
